import type { Movement } from '../types';

export const mockMovements: Movement[] = [
  {
    id: 'm1',
    direction: 'inbound',
    scheduledTime: '08:30',
    aircraft: {
      tailNumber: 'N123AB',
      type: 'G650',
      model: 'Gulfstream G650ER'
    },
    originDestination: '← KASE (Aspen)',
    assignedSpace: 'Hangar B-3',
    clientName: 'Johnson Aviation',
    status: 'in_progress',
    isStackingRequired: false,
    services: [
      { id: 's1-1', type: 'tow', name: 'Tow to fuel island', estimatedMinutes: 5, status: 'completed' },
      { id: 's1-2', type: 'fuel', name: 'Fuel 800 gal Jet-A', estimatedMinutes: 25, status: 'in_progress' },
      { id: 's1-3', type: 'deice', name: 'Deice (Type I)', estimatedMinutes: 15, status: 'pending' },
      { id: 's1-4', type: 'tow', name: 'Tow to Hangar B', estimatedMinutes: 10, status: 'pending' }
    ]
  },
  {
    id: 'm2',
    direction: 'outbound',
    scheduledTime: '09:00',
    aircraft: {
      tailNumber: 'N456CD',
      type: 'G550',
      model: 'Gulfstream G550'
    },
    originDestination: '→ KJFK (New York)',
    assignedSpace: 'Hangar A',
    clientName: 'Westfield Corp',
    status: 'in_progress',
    services: [
      { id: 's2-1', type: 'tow', name: 'Pull from hangar', estimatedMinutes: 10, status: 'completed' },
      { id: 's2-2', type: 'fuel', name: 'Fuel 600 gal Jet-A', estimatedMinutes: 15, status: 'in_progress' },
      { id: 's2-3', type: 'tow', name: 'Tow to ramp', estimatedMinutes: 5, status: 'pending' }
    ]
  },
  {
    id: 'm3',
    direction: 'inbound',
    scheduledTime: '10:15',
    aircraft: {
      tailNumber: 'N789XY',
      type: 'CL35',
      model: 'Challenger 350'
    },
    originDestination: '← KTEB (Teterboro)',
    assignedSpace: 'TD-05',
    clientName: 'Pacific Holdings',
    status: 'confirmed',
    services: [
      { id: 's3-1', type: 'fuel', name: 'Fuel 400 gal Jet-A', estimatedMinutes: 15, status: 'pending' },
      { id: 's3-2', type: 'tow', name: 'Tow to TD-05', estimatedMinutes: 10, status: 'pending' }
    ]
  },
  {
    id: 'm4',
    direction: 'outbound',
    scheduledTime: '11:30',
    aircraft: {
      tailNumber: 'N012LM',
      type: 'CJ4',
      model: 'Cessna Citation CJ4'
    },
    originDestination: '→ KORD (Chicago)',
    assignedSpace: 'Ramp',
    clientName: 'Private Owner',
    status: 'scheduled',
    services: [] // Self service, no prep
  },
  {
    id: 'm5',
    direction: 'inbound',
    scheduledTime: '14:00',
    aircraft: {
      tailNumber: 'N345PQ',
      type: 'PC12',
      model: 'Pilatus PC-12 NG'
    },
    originDestination: '← KLAS (Las Vegas)',
    assignedSpace: 'Hangar C-1',
    clientName: 'Coast Air',
    status: 'scheduled',
    isStackingRequired: true,
    services: [
      { id: 's5-1', type: 'tow', name: 'Tow to staging', estimatedMinutes: 5, status: 'pending' },
      { id: 's5-2', type: 'fuel', name: 'Fuel 200 gal Jet-A', estimatedMinutes: 15, status: 'pending' },
      { 
        id: 's5-3', 
        type: 'stacking', 
        name: 'Stacking: into Hangar C-1', 
        estimatedMinutes: 30, 
        status: 'pending',
        stacking: {
          id: 'st-5',
          trigger: 'N345PQ arriving into Hangar C, Position 1',
          totalMinutes: 30,
          crewRequired: '2 tug operators + 1 wing walker',
          notes: [
            'N678RS departs at 14:45 — if delayed, must return to hangar',
            'N901TU wingspan 52ft — clearance: 4ft. Wing walker required.'
          ],
          steps: [
            { id: 'st-5-1', action: 'Pull Out', aircraft: 'N678RS', from: 'HC-1', to: 'Ramp Hold', duration: 5, status: 'pending' },
            { id: 'st-5-2', action: 'Shift', aircraft: 'N901TU', from: 'HC-3', to: 'HC-2', duration: 10, status: 'pending' },
            { id: 'st-5-3', action: 'Tow In', aircraft: 'N345PQ', from: 'Staging', to: 'HC-1', duration: 5, status: 'pending' },
            { id: 'st-5-4', action: 'Push Back', aircraft: 'N901TU', from: 'HC-2', to: 'HC-3', duration: 5, status: 'pending' },
            { id: 'st-5-5', action: 'Stay', aircraft: 'N678RS', from: 'Ramp Hold', to: 'Ramp', duration: 0, status: 'pending' },
          ]
        }
      },
      { id: 's5-4', type: 'catering', name: 'Client pickup', estimatedMinutes: 0, status: 'pending', notes: 'Passenger arrival 14:30' }
    ]
  },
  {
    id: 'm6',
    direction: 'outbound',
    scheduledTime: '14:45',
    aircraft: {
      tailNumber: 'N678RS',
      type: 'PC24',
      model: 'Pilatus PC-24'
    },
    originDestination: '→ KDEN (Denver)',
    assignedSpace: 'Hangar C-1',
    clientName: 'Summit Jet',
    status: 'scheduled',
    isStackingRequired: true,
    services: [
      { 
        id: 's6-1', 
        type: 'stacking', 
        name: 'Stacking (Linked with N345PQ)', 
        estimatedMinutes: 20, 
        status: 'pending',
        stacking: {
           id: 'st-6',
           trigger: 'N345PQ Arrival (Displacement)',
           totalMinutes: 20,
           crewRequired: 'See N345PQ Stacking',
           notes: [],
           steps: [
               { id: 'st-6-1', action: 'Pull Out', aircraft: 'N678RS', from: 'HC-1', to: 'Ramp Hold', duration: 5, status: 'pending' },
           ]
        }
      },
      { id: 's6-2', type: 'fuel', name: 'Fuel 350 gal Jet-A', estimatedMinutes: 15, status: 'pending' }
    ]
  },
  {
    id: 'm7',
    direction: 'outbound',
    scheduledTime: '16:00',
    aircraft: {
      tailNumber: 'N901TU',
      type: 'G280',
      model: 'Gulfstream G280'
    },
    originDestination: '→ KMIA (Miami)',
    assignedSpace: 'Hangar C-3',
    clientName: 'Apex Aviation',
    status: 'scheduled',
    services: [
      { id: 's7-1', type: 'fuel', name: 'Fuel 500 gal Jet-A', estimatedMinutes: 15, status: 'pending' }
    ]
  }
];
